<template>
    <div class="more_menu">
        <button class="button_clear unbind_btn" @click.stop="handleShowList">
            <i class="icon icon-co_more-2"/>
        </button>
        <ul class="btn_list" v-show="showList">
            <li v-for="item in btnItems" :key="item.text" @click="item.onClick">
                {{ item.text }}
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { CloseMenuEvent, eventBus, getEmitterId } from '../lib/eventBus';

export interface IBtnItem {
    text: string;
    onClick: () => any;
}

export default Vue.extend({
    props: {
        btnItems: Array as PropType<IBtnItem[]>
    },
    data() {

        return {
            showList: false,
            id: getEmitterId()
        };

    },
    created() {

        eventBus.addEventListener( 'close-menu', this.hideList );

    },
    mounted() {

        document.body.addEventListener( 'click', this.hideList );

    },
    beforeDestroy() {

        document.body.removeEventListener( 'click', this.hideList );
        eventBus.removeEventListener( 'close-menu', this.hideList );

    },
    methods:{
        hideList( arg: CloseMenuEvent| Event ) {

            if ( arg instanceof CloseMenuEvent && arg.detail.senderId === this.id ) {

                return;

            }
            this.showList = false;

        },
        handleShowList() {

            this.showList = !this.showList;
            eventBus.dispatchEvent( new CloseMenuEvent( this.id ));

        }
    },
});
</script>

<style lang="less" scoped>
.more_menu {
    position: relative;
    .unbind_btn{
        .icon{
            font-size: 24px;
        }
        &:hover{
            background-color: @bg_01;
            border-radius: 4px;
        }
    }
    ul.btn_list {
        position: absolute;
        left: 50%;
        top: 100%;
        z-index: 10;
        background-color: @bg_02;
        border: 1px solid @line;
        border-radius: 8px;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.23);
        overflow: hidden;

        @media @mobile {
            left: auto;
            right: 0;
        }

        li {
            position: relative;
            font-family: @font_02;
            font-size: 14px;
            font-weight: 500;
            line-height: normal;
            letter-spacing: 0em;
            color: @font_primary;
            width: 280px;
            display: flex;
            padding: 8px 0;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            cursor: pointer;

            .device_detail_main_card_more_menu_items {
                left: 100%;
                top: 0;

                @media @mobile {
                    left: -10%;
                    top: 100%;
                }
            }

            &:hover {
                background-color: @brand_light;
                color: @white;
            }

            &.active {
                background-color: @brand_light;
                color: @white;
            }

            .danger_tip {
                font-size: 12p;
                font-weight: 500;
                color: @warning;
            }
        }
    }
}
</style>
